//TODO: TEST!
(function (upp) {
    'use strict';
    upp.directive('rrssIconsTpl', ['aboutService', 'config', 'device', 'urlResolver',
        function (aboutService, config, device, urlResolver) {
            return {
                restrict: 'E',
                templateUrl: require('../templates/rrss-icons.html'),
                replace: true,

                link: function ($scope, $element, attrs) {
                    $scope.config = {};
                    $scope.about = $scope.about || {};

                    /**
                     * Control the url to open
                     */
                    $scope.openMap = function () {
                        if ($scope.location && $scope.location.locationMaps[0])
                            urlResolver.open($scope.location.locationMaps[0].url)
                    };

                    /**
                     * @method preparePhone
                     *
                     * @param {String} phoneNumber
                     * @return {String} url fot phone link
                     */
                    var preparePhone = function (phoneNumber) {
                        var phoneLink;
                        if (phoneNumber) {
                            if (device.isMobile()) {
                                phoneLink = 'tel:' + phoneNumber;
                            } else {
                                phoneLink = '#!/about/contact';
                            }
                        }
                        return phoneLink;
                    };

                    /**
                     * get the object or property with the name like the key param
                     * from the Array info
                     * @param info Array with objects
                     * @param key String the field to find inside the Array's object
                     * @returns {undefined} or an object
                     */
                    function getSection(info, key) {
                        var result = undefined;
                        info.every(function (item) {
                            if (item.type === key) {
                                result = item;
                                return false;
                            }
                            return true;
                        });
                        return result;
                    }

                    if (!attrs.hideEshop) {
                        //Check if the module 'eshop' is active, so the button can be shown
                        config.isAnActiveModule('eshop')
                            .then(function () {
                                $scope.config.eshop = true;
                            });
                    }

                    config.isAnActiveModule('about')
                        .then(function () {
                            aboutService.getInfo()
                                .then(function (info) {
                                    $scope.location = getSection(info, 'LOCATION');
                                    $scope.about = getSection(info, 'CONTACT');
                                    if ($scope.about && $scope.about.contactPhone) {
                                        $scope.about.phone = preparePhone($scope.about.contactPhone);
                                    }
                                });
                        });

                }
            }
        }])
    ;

})(upp);


// WEBPACK FOOTER //
// ./src/app/common/directives/home_icons-directive.js